<script setup lang="ts">
import DashboardPanel from '@/modules/dashboard/components/DashboardPanel.vue';
import AgreementsTable from '@/modules/agreements/components/AgreementsTable.vue';
import AgreementView from '@/modules/agreements/components/AgreementView.vue';
import { nextTick, shallowRef, watch } from 'vue';
import { Agreement, Data } from '@/connect';
import { CompanyInfo } from '@/modules/common/models';
import BrokerCompanySelector from '@/modules/broker-admin/views/BrokerCompanySelector.vue';

const agreementView = shallowRef<null | Data<Agreement>>(null);
const selectedCompany = shallowRef<null | CompanyInfo>(null);

const shouldRenderTable = shallowRef(true);

// forces the table to re-render avoiding flickering issues when the company is changed
watch(selectedCompany, async () => {
  shouldRenderTable.value = false;
  await nextTick();
  shouldRenderTable.value = true;
});
</script>

<template>
  <div>
    <div class="d-flex align-center justify-space-between">
      <div class="d-flex gap-1">
        <BrokerCompanySelector v-model="selectedCompany" class="company-selector" />
      </div>
    </div>
    <DashboardPanel no-collapse title="Agreements">
      <VCard class="flex d-flex flex-column">
        <AgreementView
          v-if="agreementView !== null"
          :agreement="agreementView"
          @cancel="agreementView = null"
        />
        <AgreementsTable
          v-if="shouldRenderTable"
          :company-id-filter="selectedCompany?.companyId"
          data-test="agreements-table"
          @view="(value) => (agreementView = value)"
        />
      </VCard>
    </DashboardPanel>
  </div>
</template>

<style lang="scss">
.company-selector {
  width: 325px;
}
</style>
